import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import Spinner from '../../Spinner/Spinner'
import { Input, FormGroup, Label, Table, Button } from 'reactstrap'
import { SCHEMAS_QUERY } from '../../../graphql'
//import { publishEvent } from '../../../utils'

const SCHEMAS = gql(SCHEMAS_QUERY)

export default function ExxecuteSQL({ handleChange }) {
  console.log('ExxecuteSQL rendered')

  // function publishChange(e) {
  //   console.log('ExxecuteSQL: ', e.target.value)
  //   publishEvent('SCHEMA_SELECTED', e.target.value, 'ExxecuteSQL')
  // }

  //const changeFunction = handleChange ? (e) => handleChange(e) : (e) => publishChange(e)

  const { loading, error, data } = useQuery(SCHEMAS, { fetchPolicy: 'cache-first' })
  if (loading) {
    return <Spinner />
  }
  if (error) {
    return error.message
  }

  for (let i = 0; i < data.schemas.length; i++) {
    // const schema = data.schemas[i]
    //   <td>
    //     <Input type="checkbox" name="schema" id={schema.name} value={schema.name} onChange={(e) => changeFunction(e)} />
    //     <Label for={schema.name} style={{ marginLeft: '5px' }}>{schema.name}</Label>
    //   </td>
  }


  return (
    <div style={{ padding: '10px'}}>
      <FormGroup>
        <Label for="sql">SQL</Label>
        <Input id="sql" name="sql" type="textarea" style={{ height: '100px'}} />
      </FormGroup>
      <Table>
        <thead><tr><th>Target Schemas</th></tr></thead>
        <tbody>
          <tr>
            <td>
              <Button style={{ marginRight: '10px' }}>Select All</Button>
              <Button>Clear All</Button>
            </td>
          </tr>
          <tr>
          </tr>
        </tbody>
      </Table>
    </div>
  )
}